import { render, staticRenderFns } from "./IdentityInfo.vue?vue&type=template&id=41836052&"
import script from "./IdentityInfo.vue?vue&type=script&lang=js&"
export * from "./IdentityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports